package one.healthium.insights.domain.models

data class NavbarModel(
    val title: String?,
    val color: Long?,
    val style: NabBarStyle,
    val image: String?,
    val actions: List<ActionModel>?,
)

enum class NabBarStyle {
    Default, Large
}
